document.addEventListener('DOMContentLoaded', function () {
  function getSelectedMainColor() {
    var selectedInput = document.querySelector(
      '.product-form__input input[type="radio"]:checked, fieldset input[type="radio"]:checked, .variant-radios input[type="radio"]:checked'
    );
    if (selectedInput && selectedInput.value) {
      return selectedInput.value.trim();
    }
    var activeLabel = document.querySelector(
      'label.tm_var-colr-btn.active, .product-form__input label.active'
    );
    if (activeLabel && activeLabel.textContent) {
      return activeLabel.textContent.trim();
    }
    var selectedOpt = document.querySelector(
      'select[name*="options"] option:selected, select[id*="Variants"] option:selected'
    );
    if (selectedOpt && selectedOpt.textContent) {
      return selectedOpt.textContent.trim();
    }
    return null;
  }

  function syncFbtVariants(colorName) {
    if (!colorName) return;
    var cleanColor = colorName.toLowerCase().trim();
    var fbtSection = document.querySelector('.tm_product-accessories');
    if (!fbtSection) return;

    var productCards = fbtSection.querySelectorAll('.tm_collection-item');
    productCards.forEach(function (card) {
      var swatches = card.querySelectorAll('.tm_colle_colour li');
      var matchedSwatch = null;

      swatches.forEach(function (swatch) {
        var swatchName = (swatch.getAttribute('data-name') || '').toLowerCase().trim();
        if (swatchName === cleanColor || swatch.classList.contains('color-swatch--' + cleanColor)) {
          matchedSwatch = swatch;
        }
      });

      if (matchedSwatch) {
        swatches.forEach(function (s) {
          s.classList.remove('var-outline', 'active_color');
        });
        matchedSwatch.classList.add('var-outline', 'active_color');

        var newImgSrc = matchedSwatch.getAttribute('data-img');
        var imgEl = card.querySelector('a.figure_slot img, .figure_slot img');
        if (imgEl && newImgSrc) {
          imgEl.setAttribute('src', newImgSrc);
          imgEl.setAttribute('srcset', newImgSrc);
        }

        var linkEl = matchedSwatch.querySelector('a');
        if (linkEl) {
          var newUrl = linkEl.getAttribute('href');
          var titleLink = card.querySelector('a.tm_lg-font, .figure_slot');
          if (titleLink && newUrl) {
            titleLink.setAttribute('href', newUrl);
          }
        }

        var newSku = matchedSwatch.getAttribute('data-sku');
        var modelEl = card.querySelector('.tm_colle-modal h5');
        if (modelEl && newSku) {
          modelEl.textContent = 'Model: ' + newSku.replace(/^Model:\s*/i, '');
        }

        // Client: on a product whose own colour is White, a "Junction Boxes"
        // card showed White (swatch, photo, Model text - all synced above)
        // but "Add to basket" put the GREY one in the basket. Everything
        // above this line is presentation; the two things that actually
        // decide which variant is added were never updated, so they both
        // still held what Liquid rendered -
        // card_product.selected_or_first_available_variant, i.e. the
        // product's first AVAILABLE variant (Grey), regardless of what the
        // card was showing. Take the id straight off this swatch's own link,
        // which Liquid already built as ".../products/x?variant=<id>" for
        // exactly this variant.
        var variantId = null;
        if (linkEl) {
          var variantMatch = (linkEl.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
          if (variantMatch) variantId = variantMatch[1];
        }
        if (variantId) {
          // The plain product form's hidden input (used when a card renders
          // without the Amazon-style stepper).
          var idInput = card.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;

          // fbt-cart-stepper.js reads THIS attribute - not the form input -
          // for both its optimistic add and its +/- steps, so on a card with
          // a stepper this is the one that decides what lands in the basket.
          // It also re-reads the basket when this changes, so the card's
          // "N in basket" state follows the colour instead of reporting the
          // other colour's quantity.
          var stepperEl = card.querySelector('.fbt-basket-stepper');
          if (stepperEl && stepperEl.getAttribute('data-variant-id') !== variantId) {
            stepperEl.setAttribute('data-variant-id', variantId);
          }
        }
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('.product-form__input, variant-radios, variant-selects, .tm_var-colr-btn, [name*="options"], form[data-type="add-to-cart-form"]')) {
      var mainColor = getSelectedMainColor();
      if (mainColor) {
        syncFbtVariants(mainColor);
      }
    }
  });

  document.addEventListener('click', function (e) {
    var radioOrLabel = e.target.closest('.product-form__input input, label.tm_var-colr-btn, .variant-radios label');
    if (radioOrLabel) {
      setTimeout(function () {
        var mainColor = getSelectedMainColor();
        if (mainColor) {
          syncFbtVariants(mainColor);
        }
      }, 100);
    }
  });

  setTimeout(function () {
    var initialColor = getSelectedMainColor();
    if (initialColor) {
      syncFbtVariants(initialColor);
    }
  }, 500);
});
